import { Head, Link, useForm } from '@inertiajs/inertia-react';
import { MODALS } from 'app/components/Layouts/Modals';
import Checkbox from 'app/fragments/Forms/Checkbox';
import Form from 'app/fragments/Forms/Form';
import PasswordField from 'app/fragments/Forms/PasswordField';
import Submit from 'app/fragments/Forms/Submit';
import TextField from 'app/fragments/Forms/TextField';
import React from 'react'
import route from 'ziggy-js';

interface Props { }

function Login(props: Props) {
    const { } = props

    const form = useForm({});
    const { data, post } = form;

    const submit = (e) => {
        e.preventDefault();
        post(route('login'));
    }

    return (
        <div className='bg-black flex justify-center items-center h-full min-h-screen'>
            <Head title={"Timea - Time is money"}>
                <meta head-key="description" name="description" content="Time is money friend." />
            </Head>
            <div className="flex">
                <div className=" bg-[#0D0D0D]  text-white px-30px py-55px rounded-lg mt-20 max-w-md">
                    <div className=" flex justify-center">
                        <div className="text-36 rounded-full bg-[#1A1A1A] w-100px h-100px text-center pt-16px  flex items-center">
                            <div className="flex justify-center items-center w-full">👋</div>
                        </div>
                    </div>
                    <div className="mt-48px">
                        <h1 className="text-center text-36 font-bold">Welcome back!</h1>
                        <p className="text-center mx-16px text-16 mt-16px leading-6">
                            Log in to your account and start tracking your time. You know what they say - “Time = Money”
                        </p>
                    </div>
                    <div className='mt-63px'>
                        <Form form={form} onSubmit={submit}>
                            <TextField name='email' placeholder='email@email.com' label="Email*" />
                            <PasswordField name="password" label="Heslo*" placeholder="********" />
                            <Checkbox name='remember' label={'Remember me?'} />
                            {/* <Link href={route('new.acc')}>Complete registration</Link> */}
                            <Submit className='w-full rounded-full' value="Log In" />
                        </Form>
                    </div>
                </div>
            </div>

        </div>
    )
}

export default Login
